import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const PrintIcon = ({ className = '', width = 17,  height = 17 , color = 'currentColor' }) => {
    return (
        <svg
            className={className ? className : ''}
            fill='none'
            height={height}
            viewBox='0 0 17 19'
            width={width}
            xmlns='http://www.w3.org/2000/svg'>
            <path
                clipRule='evenodd'
                d='M4 1H13V5H4L4 1ZM3 5V1C3 0.447715 3.44772 0 4 0H13C13.5523 0 14 0.447715 14 1V5H16C16.5523 5 17 5.44772 17 6V13C17 13.5523 16.5523 14 16 14H14V18C14 18.5523 13.5523 19 13 19H4C3.44772 19 3 18.5523 3 18V14H1C0.447715 14 0 13.5523 0 13V6C0 5.44772 0.447715 5 1 5H3ZM3 13V10C3 9.44772 3.44772 9 4 9H13C13.5523 9 14 9.44772 14 10V13H16V6H13H4H1L1 13H3ZM4 10H13V18H4L4 10ZM6 11.5C6 11.2239 6.22386 11 6.5 11H10.5C10.7761 11 11 11.2239 11 11.5C11 11.7761 10.7761 12 10.5 12H6.5C6.22386 12 6 11.7761 6 11.5ZM6.5 13C6.22386 13 6 13.2239 6 13.5C6 13.7761 6.22386 14 6.5 14H10.5C10.7761 14 11 13.7761 11 13.5C11 13.2239 10.7761 13 10.5 13H6.5ZM6 15.5C6 15.2239 6.22386 15 6.5 15H10.5C10.7761 15 11 15.2239 11 15.5C11 15.7761 10.7761 16 10.5 16H6.5C6.22386 16 6 15.7761 6 15.5ZM2.5 8C2.77614 8 3 7.77614 3 7.5C3 7.22386 2.77614 7 2.5 7C2.22386 7 2 7.22386 2 7.5C2 7.77614 2.22386 8 2.5 8Z'
                fill={color}
                fillRule='evenodd'/>
        </svg>

    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default PrintIcon;
